import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileExporterDataProvider } from './file-exporter.service';
import { AndroidFileExporter } from './android-file-exporter';
import { IosFileExporter } from './ios-file-exporter';
import { WebFileExporter } from './web-file-exporter';
import { ExportSanitizer } from './sanitizers/export.sanitizier';
import { ExportSanitizerReservedWords } from './sanitizers/export-sanitizer-reserved-words';
import { ExportSanitizerService } from './sanitizers';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [
		FileExporterDataProvider,
		AndroidFileExporter,
		IosFileExporter,
		WebFileExporter,
		ExportSanitizer,
		ExportSanitizerReservedWords,
		ExportSanitizerService
	]
})
export class JSONFileExporterModule {}
